import React, { useState, useContext, useEffect } from "react";
import { RootContext } from "../../../RootContextProvider";
import { Button, message, Row, Col, Input, Form, Upload, Radio } from "antd";
import "./../../addNewLinkRegular/AddNewLinkRegular.css";
import { verticalFormLayout } from "../../../utils/forms";
import {
  addNewLinkToPage,
  updateLink,
  deleteLink,
  uploadThumbnailPictureToAWS,
} from "../../../utils/links";
import "../ModalLinkCreation.css";
import { IoIosImages } from "react-icons/io";
import PlanLink from "../PlanLink";
import {
  isStatusAllowedToPush,
  validateLinkContent,
} from "../../../utils/utils";
import moment from "moment";
import momentTz from "moment-timezone";
import {
  DeleteOutlined,
  ArrowLeftOutlined,
  ReloadOutlined,
  LoadingOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { fetchMetaData } from "../../../utils/links";
import ClassicLargeThumbnail from "./ThumbnailPicker/ClassicLargeThumbnail";
import IntegratedLargeThumbnail from "./ThumbnailPicker/IntegratedLargeThumbnail";
import ClassicSmallThumbnail from "./ThumbnailPicker/ClassicSmallThumbnail";

import thumbnailSimpleIcon from "../../../assets/icons/thumbnail-thumbnail.svg";
import thumbnailIntegrated from "../../../assets/icons/integrated-thumbnail.svg";
import thumbnailLarge from "../../../assets/icons/thumbnail-large.svg";
// import PremiumTag from "../../Billing/PremiumTag";
import ModalUpgradeLinks from "../../Locker/ModalUpgradeLinks";

const BlockThumbnail = ({
  setModalOpen,
  isEdittingLink,
  setEdittingLink,
  linkEditDetails,
  currentLinks,
  setRefresh,
  refresh,
  setDisplayBlockPicker,
}) => {
  const [form] = Form.useForm();

  const [loading, setLoading] = useState(true);
  const [loadingMeta, setLoadingMeta] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const [isScheduled, setIsScheduled] = useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [url, setUrl] = useState();
  const [title, setTitle] = useState();
  const [thumbnail, setThumbnail] = useState();
  const [thumbnailType, setThumbnailType] = useState("full");
  const [fileList, setFileList] = useState([]);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);

  const { pages, account } = useContext(RootContext);

  useEffect(() => {
    const populateFields = () => {
      if (isEdittingLink) {
        console.log("editing mode");
        form.setFieldsValue({
          url: linkEditDetails.LinkUrl,
          title: linkEditDetails.LinkTitle,
          embedCode: linkEditDetails.LinkEmbedCode,
        });

        setUrl(linkEditDetails.LinkUrl);
        setThumbnailType(linkEditDetails.LinkType.split("-")[1]);
        setThumbnail(linkEditDetails.LinkImage);
        setTitle(linkEditDetails.LinkTitle);
        setLoading(false);
        if (linkEditDetails.IsScheduled) {
          setIsScheduled(true);
          setEndDate(moment(linkEditDetails.EndDate));
          setStartDate(moment(linkEditDetails.StartDate));
          setLoading(false);
        }
      } else {
        console.log("normal mode");
        form.setFieldsValue({
          url: "",
          title: "",
          embedCode: "",
        });
        setThumbnail();
        setIsScheduled(false);
        setStartDate();
        setEndDate();
        setLoading(false);
        // form.resetFields();
      }
    };
    populateFields();
    // eslint-disable-next-line
  }, [isEdittingLink, linkEditDetails]);

  const onChangeUrl = async (url) => {
    setUrl(url);
  };

  const getThumbnail = async () => {
    try {
      if (url) {
        console.log(url);
        setLoadingMeta(true);
        let data = await fetchMetaData(url);
        console.log(data);
        if (data && data.title) {
          setTitle(data.title);
          form.setFieldsValue({
            title: data.title,
            embedCode: "",
          });
        }
        if (data && data.image) {
          setThumbnail(data.image);
        }
        if (!data.image) {
          message.error(
            "Aucune image détectée via ce lien. Téléchargez directement votre image."
          );
        }
      } else {
        message.error("Veuillez renseigner une URL valide");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoadingMeta(false);
    }
  };

  const uploadImage = async (options) => {
    const { onSuccess, onError, file } = options;
    try {
      const fmData = new FormData();
      fmData.append("image", file);
      setLoadingImage(true);
      let imageUrl = await uploadThumbnailPictureToAWS(fmData);
      console.log(imageUrl);
      if (imageUrl) {
        setThumbnail(imageUrl.imageUrl);
        onSuccess("Ok");
      } else {
        setThumbnail();
      }
    } catch (err) {
      console.log("Error: ", err);
      new Error("Some error");
      onError({ err });
    } finally {
      setLoadingImage(false);
    }
  };

  const handleChange = async ({ file, fileList }) => {
    // setFileList(fileList);
    if (!file.status) {
      file.status = "error";
      setFileList([file]);
    } else {
      setFileList(fileList);
    }
    if (fileList.length === 0) {
      // setImageUrl();
    }
  };

  const handleBeforeUpload = (file) => {
    const isSmallerThan2Mb = file.size / 1024 / 1024 < 2;
    if (!isSmallerThan2Mb) {
      message.error("Votre image ne doit pas dépasser 2 Mo.");
      return false;
    } else {
      return true;
    }
  };

  const showUploadList = {
    showDownloadIcon: false,
    showRemoveIcon: false,
    showUploadList: false,
  };

  const onFinish = async (values) => {
    try {
      let isAllowedToPush = isStatusAllowedToPush(
        isScheduled,
        startDate,
        endDate
      );
      let validLinkContent = await validateLinkContent(
        values.url,
        account.IsPaying
      );
      console.log(validLinkContent);
      if (isAllowedToPush) {
        if (!validLinkContent.err) {
          if (!isEdittingLink) {
            let linkDetails = {
              type: `thumbnail-${thumbnailType}`,
              title: values.title,
              url: values.url,
              image: thumbnail,
              embedCode: values.embedCode,
              index: currentLinks ? currentLinks.length : 0,
              isScheduled,
              startDate: momentTz(startDate).utc().format("YYYY-MM-DD HH:mm"),
              endDate: momentTz(endDate).utc().format("YYYY-MM-DD HH:mm"),
            };
            await addNewLinkToPage(pages.PageID, linkDetails);

            setRefresh(refresh + 1);
          } else {
            // update link info
            // close modal
            console.log(`thumbnail-${thumbnailType}`);
            let linkDetails = {
              id: linkEditDetails.LinkID,
              type: `thumbnail-${thumbnailType}`,
              title: values.title,
              image: thumbnail,
              url: values.url,
              index: linkEditDetails.LinkIndex,
              isScheduled,
              startDate: momentTz(startDate).utc().format("YYYY-MM-DD HH:mm"),
              endDate: momentTz(endDate).utc().format("YYYY-MM-DD HH:mm"),
            };
            let isUpdated = await updateLink(pages.PageID, linkDetails);
            if (isUpdated.message) {
              message.success("Lien modifié avec succès");
              setEdittingLink(false);
              setRefresh(refresh + 1);
            } else {
              message.error("Erreur lors de la modification");
            }
          }
          setModalOpen(false);
        } else {
          message.warning(validLinkContent.err);
        }
      } else {
        message.warning(
          "Veuillez renseigner une date de début et fin à votre lien"
        );
      }
    } catch (e) {
      console.log(e);
      message.error("Erreur lors de l'ajout de votre lien");
    }
  };

  const onFinishFailed = async () => {
    console.log("Bugggg");
  };

  const delLink = async () => {
    let deletedLink = await deleteLink(pages.PageID, linkEditDetails.LinkID);

    if (deletedLink.message) {
      message.success("Lien supprimé avec succès");
      setRefresh(refresh + 1);
    } else {
      message.error("Erreur lors de la suppression");
    }
    cancelModal();
  };

  const cancelModal = () => {
    setModalOpen(false);
    setTimeout(() => {
      setEdittingLink(false);
    }, 200);
  };

  return (
    <div>
      <div className="modal-header">
        <Row>
          <Col span={2} className="back-link">
            {!isEdittingLink ? (
              <div
                onClick={() => {
                  setDisplayBlockPicker(true);
                }}
              >
                <ArrowLeftOutlined style={{ marginRight: "5px" }} />
              </div>
            ) : (
              ""
            )}
          </Col>
          <Col span={20}>
            <div className="modal-title">
              <IoIosImages className="icon-modal-title" /> Paramètrez votre lien
              avec miniature
              {/* {!account.IsPaying ? (
                <div className="premium-block">
                  <PremiumTag size="medium" hasIcon={false} />
                </div>
              ) : (
                ""
              )} */}
            </div>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>
      <div className="modal-body">
        <Form
          className="form-signup align-left"
          layout="vertical"
          form={form}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          {...verticalFormLayout}
        >
          <Form.Item
            label="URL du lien"
            name="url"
            rules={[
              { required: true, message: "Insérez votre url" },
              { type: "url", message: "Veuillez entrer une URL valide." },
              {
                max: 400,
                message: "Votre URL doit faire maximum 400 caractères",
              },
            ]}
          >
            <Input
              className="auth-input"
              placeholder="https://monsite.com"
              onChange={(e) => {
                onChangeUrl(e.target.value);
              }}
            />
          </Form.Item>
          <div className="btn-section-fetch">
            <Button
              className="get-thumbnail"
              onClick={() => {
                getThumbnail();
              }}
              loading={loadingMeta}
              icon={<ReloadOutlined />}
              disabled={url ? false : true}
            >
              Générer miniature
            </Button>
            <span style={{ margin: "0px 20px" }}>OU</span>
            {account.IsPaying ? (
              <Upload
                fileList={fileList}
                customRequest={uploadImage}
                showUploadList={showUploadList}
                onChange={handleChange}
                beforeUpload={handleBeforeUpload}
                accept=".jpg,.png"
                disabled={
                  !account.IsPaying ? true : !url || loading ? true : false
                }
              >
                <div className="edit-picture">
                  <div>
                    {!loadingImage ? <UploadOutlined /> : <LoadingOutlined />}
                  </div>
                  Télécharger une image de fond
                </div>
              </Upload>
            ) : (
              <Button
                className="get-thumbnail disabled"
                onClick={() => {
                  setShowUpgradeModal(true);
                }}
                icon={<UploadOutlined />}
                // disabled={true}
              >
                Télécharger une image de fond
              </Button>
            )}
            <div
              className="subtitle-edit-picture"
              style={{ marginLeft: "20px" }}
            >
              (meilleur format: 400x400){" "}
            </div>
          </div>
          <div className="explain-thumbnail">
            Générer la miniature permet de transférer l'image et le titre de
            votre page vers ce bouton. Vous pouvez également ajuster
            manuellement l'image ou le titre.
          </div>
          <Form.Item
            label="Titre du lien"
            name="title"
            rules={[
              { required: true, message: "Insérez votre titre" },
              {
                max: 100,
                message: "Votre titre doit faire 100 caractères maximum.",
              },
            ]}
          >
            <Input
              className="auth-input"
              placeholder="Mon super lien"
              maxLength={100}
              onChange={(e) => {
                setTitle(e.target.value);
              }}
            />
          </Form.Item>

          {/* <Form.Item
            name="boost"
            // rules={[{ required: true, message: "Insérez votre url" }]}
          >
            <div className="animate-link-section">
              {" "}
              <Switch />
              <div style={{ marginLeft: "10px" }}>
                Animation pour faire ressortir le lien
              </div>
            </div>
          </Form.Item> */}
          {!loading ? (
            <PlanLink
              isScheduled={isScheduled}
              setIsScheduled={setIsScheduled}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              startDate={startDate}
              endDate={endDate}
              // loading={loading}
            />
          ) : (
            ""
          )}

          {thumbnail ? (
            <>
              <div className="thumbnail-picker">
                <Radio.Group
                  onChange={(e) => {
                    setThumbnailType(e.target.value);
                  }}
                  value={thumbnailType}
                >
                  <Radio value="thumbnail">
                    <img src={thumbnailSimpleIcon} alt="icon thumb picker" />
                  </Radio>
                  <Radio value="integrated">
                    <img src={thumbnailIntegrated} alt="icon thumb picker" />
                  </Radio>
                  <Radio value="full">
                    <img src={thumbnailLarge} alt="icon thumb picker" />
                  </Radio>
                </Radio.Group>
              </div>
              <div className="preview-thumbnail">
                {thumbnailType === "full" ? (
                  <ClassicLargeThumbnail image={thumbnail} title={title} />
                ) : thumbnailType === "integrated" ? (
                  <IntegratedLargeThumbnail image={thumbnail} title={title} />
                ) : (
                  <ClassicSmallThumbnail image={thumbnail} title={title} />
                )}
              </div>
            </>
          ) : (
            ""
          )}
          {/* {!account.IsPaying ? (
            <div className="upgrade-explain">
              Veuillez <Link to="/billing">passer au plan premium</Link> pour
              débloquer le bloc Miniature.
            </div>
          ) : (
            ""
          )} */}
          <Form.Item style={{ textAlign: "center", marginTop: "20px" }}>
            <Button
              className="submit-link"
              htmlType="submit"
              loading={loading}
              size="large"
              // disabled={account.IsPaying ? false : true}
            >
              Sauvegarder
            </Button>
            {isEdittingLink ? (
              <div
                className="del-link-mobile"
                onClick={() => {
                  delLink();
                }}
              >
                <DeleteOutlined style={{ marginRight: "5px" }} />
                Supprimer
              </div>
            ) : (
              ""
            )}
          </Form.Item>
        </Form>
      </div>
      <ModalUpgradeLinks
        setShowUpgradeModal={setShowUpgradeModal}
        showUpgradeModal={showUpgradeModal}
        subtitle="Téléchargez votre propre image en premium"
      />
    </div>
  );
};

export default BlockThumbnail;
